import { RequestModel } from './request-model.model';

export class RequestorModel {
    private _contactFullName: string;
    private _contactEmail: string;
    private _contactSignature: boolean;
    private _contactFax: string;
    private _contactRequests: RequestModel[];
    private _contactState: string;
    private _contactCountry: string;
    private _contactCapcha: string;
    private _contactPhone: string;
    private _capchaDate: Date;
    private _requestorFaxRegion: string;
    private _requestorPhoneRegion: string;


    constructor(contactFullName?: string, contactEmail?: string, contactSignature?: boolean,
                contactFax?: string, contactRequests?: RequestModel, contactState?: string,
                contactCountry?: string, contactCapcha?: string, contactPhone?: string,
                capchaDate?: Date, requestorFaxRegion?: string, requestorPhoneRegion?: string ) {

    }

    public get capchaDate(): Date {
        return this._capchaDate;
    }
    public set capchaDate(value: Date) {
        this._capchaDate = value;
    }
    public get contactFullName(): string {
        return this._contactFullName;
    }
    public set contactFullName(value: string) {
        this._contactFullName = value;
    }
    public get contactPhone(): string {
        return this._contactPhone;
    }
    public set contactPhone(value: string) {
        this._contactPhone = value;
    }
    public get contactEmail(): string {
        return this._contactEmail;
    }
    public set contactEmail(value: string) {
        this._contactEmail = value;
    }
    public get contactCapcha(): string {
        return this._contactCapcha;
    }
    public set contactCapcha(value: string) {
        this._contactCapcha = value;
    }
    public get contactCountry(): string {
        return this._contactCountry;
    }
    public set contactCountry(value: string) {
        this._contactCountry = value;
    }
    public get contactState(): string {
        return this._contactState;
    }
    public set contactState(value: string) {
        this._contactState = value;
    }
    public get contactRequests(): RequestModel[] {
        return this._contactRequests;
    }
    public set contactRequests(value: RequestModel[]) {
        this._contactRequests = value;
    }
    public get contactFax(): string {
        return this._contactFax;
    }
    public set contactFax(value: string) {
        this._contactFax = value;
    }
    public get contactSignature(): boolean {
        return this._contactSignature;
    }
    public set contactSignature(value: boolean) {
        this._contactSignature = value;
    }
    public get requestorFaxRegion(): string {
        return this._requestorFaxRegion;
    }
    public set requestorFaxRegion(value: string) {
        this._requestorFaxRegion = value;
    }
    public get requestorPhoneRegion(): string {
        return this._requestorPhoneRegion;
    }
    public set requestorPhoneRegion(value: string) {
        this._requestorPhoneRegion = value;
    }
}
